(function () {
  'use strict';

  window.AIPDPThemeAdapters = window.AIPDPThemeAdapters || {};
  if (window.AIPDPThemeAdapters.shrine) return;

  function first(root, selectors) {
    var scope = root && root.querySelector ? root : document;
    for (var i = 0; i < selectors.length; i += 1) {
      var match = scope.querySelector(selectors[i]);
      if (match) return match;
    }
    return null;
  }

  function productScope(root) {
    return (
      root.closest('product-info') ||
      root.closest('[id^="MainProduct-"]') ||
      root.closest('.product__info-container') ||
      root.closest('.product-info') ||
      root.closest('.shopify-section') ||
      document
    );
  }

  function formFromHost(host) {
    if (!host) return null;
    if (host.matches && host.matches('form')) return host;
    return first(host, [
      'form[action*="/cart/add"]',
      'form[id^="product-form-"]',
      'form'
    ]);
  }

  function findProductForm(root, configuredId) {
    if (configuredId) {
      var configured = document.getElementById(configuredId);
      var configuredForm = formFromHost(configured);
      if (configuredForm) return configuredForm;
    }

    var scope = productScope(root);
    var mainHost = first(scope, [
      'product-form[data-main="true"]',
      'product-form',
      '[data-product-form]'
    ]);
    var mainForm = formFromHost(mainHost);
    if (mainForm) return mainForm;

    var scopedForm = first(scope, [
      'form[action*="/cart/add"]',
      'form[id^="product-form-"]'
    ]);
    if (scopedForm) return scopedForm;

    var allForms = Array.prototype.slice.call(
      document.querySelectorAll('form[action*="/cart/add"], form[id^="product-form-"]')
    );
    return allForms.find(function (form) {
      return form.querySelector('[name="id"]');
    }) || null;
  }

  function variantInput(form) {
    if (!form) return null;
    return first(form, [
      'input[name="id"]:not([disabled])',
      'select[name="id"]:not([disabled])',
      '[name="id"]:not([disabled])'
    ]);
  }

  function getVariantId(form) {
    var input = variantInput(form);
    if (!input) return 0;
    return Number(input.value || input.getAttribute('value')) || 0;
  }

  function setQuantity(form, quantity) {
    if (!form) return null;
    var input = first(form, [
      'input[name="quantity"]:not([disabled])',
      'select[name="quantity"]:not([disabled])'
    ]);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      input.setAttribute('data-ai-ppo-managed-quantity', 'true');
      form.appendChild(input);
    }
    input.value = String(Math.max(1, Number(quantity) || 1));
    input.setAttribute('value', input.value);
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return input;
  }

  function dynamicCheckoutNodes(root, form) {
    var scope = productScope(root);
    var nodes = Array.prototype.slice.call(scope.querySelectorAll([
      '.shopify-payment-button',
      '[data-shopify="payment-button"]',
      'shopify-accelerated-checkout',
      'shopify-accelerated-checkout-cart'
    ].join(',')));
    if (!nodes.length && form) {
      nodes = Array.prototype.slice.call(form.querySelectorAll([
        '.shopify-payment-button',
        '[data-shopify="payment-button"]',
        'shopify-accelerated-checkout'
      ].join(',')));
    }
    return nodes;
  }

  function setDynamicCheckoutHidden(root, form, shouldHide) {
    dynamicCheckoutNodes(root, form).forEach(function (node) {
      if (shouldHide) {
        if (node.getAttribute('data-ai-ppo-hidden-by-picker') !== 'true') {
          node.setAttribute('data-ai-ppo-was-hidden', node.hidden ? 'true' : 'false');
        }
        node.setAttribute('data-ai-ppo-hidden-by-picker', 'true');
        node.hidden = true;
        node.setAttribute('aria-hidden', 'true');
      } else if (node.getAttribute('data-ai-ppo-hidden-by-picker') === 'true') {
        var wasHidden = node.getAttribute('data-ai-ppo-was-hidden') === 'true';
        node.hidden = wasHidden;
        if (!wasHidden) node.removeAttribute('aria-hidden');
        node.removeAttribute('data-ai-ppo-hidden-by-picker');
        node.removeAttribute('data-ai-ppo-was-hidden');
      }
    });
  }

  function routeQuickPayment(paymentMethod) {
    var bridge = paymentMethod === 'paypal' ? window.ToCartByPP : window.ToCart;
    if (typeof bridge !== 'function') return false;
    bridge();
    return true;
  }

  function cartSurface() {
    return first(document, [
      'cart-drawer',
      'cart-notification',
      '[data-cart-drawer]',
      '#CartDrawer'
    ]);
  }

  function sectionsForCart(surface) {
    if (!surface || typeof surface.getSectionsToRender !== 'function') return [];
    try {
      return surface.getSectionsToRender().map(function (section) {
        return section.id;
      }).filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function hasCompleteCartSections(responseData, sectionIds) {
    if (!responseData || !responseData.sections || !sectionIds.length) return false;
    return sectionIds.every(function (id) {
      var html = responseData.sections[id];
      return typeof html === 'string' && html.trim().length > 0;
    });
  }

  async function fetchCartSections(sectionIds) {
    if (!sectionIds.length) return null;
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var separator = cartUrl.indexOf('?') === -1 ? '?' : '&';
    var url = cartUrl + separator + 'sections=' + sectionIds.map(encodeURIComponent).join(',');
    var response = await fetch(url, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    var text = await response.text();
    if (!response.ok) throw new Error('Cart sections request failed with status ' + response.status + '.');
    var sections;
    try {
      sections = JSON.parse(text);
    } catch (error) {
      throw new Error('Cart sections response was not valid JSON.');
    }
    if (sections && sections.sections) sections = sections.sections;
    if (!sections || typeof sections !== 'object') {
      throw new Error('Cart sections response was empty.');
    }
    return sections;
  }

  async function ensureCartSections(responseData, surface) {
    var data = responseData && typeof responseData === 'object' ? responseData : {};
    var sectionIds = sectionsForCart(surface);
    if (!sectionIds.length || hasCompleteCartSections(data, sectionIds)) return data;
    var fetchedSections = await fetchCartSections(sectionIds);
    data.sections = Object.assign({}, data.sections || {}, fetchedSections || {});
    if (!hasCompleteCartSections(data, sectionIds)) {
      throw new Error('Cart sections were incomplete after refresh.');
    }
    return data;
  }

  async function afterAdd(responseData, context) {
    var behavior = context.behavior || 'drawer';
    if (behavior === 'cart') {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return true;
    }

    var surface = context.cartSurface || cartSurface();
    var rendered = false;
    var renderData = responseData;
    if (surface && typeof surface.renderContents === 'function') {
      try {
        renderData = await ensureCartSections(responseData, surface);
        surface.renderContents(renderData);
        rendered = true;
      } catch (error) {
        rendered = false;
      }
    }

    if (!rendered && behavior === 'drawer') {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }
    return rendered;
  }

  window.AIPDPThemeAdapters.shrine = {
    name: 'Shrine-PRO',
    version: '1.5.3',
    findProductForm: findProductForm,
    getVariantId: getVariantId,
    setQuantity: setQuantity,
    setDynamicCheckoutHidden: setDynamicCheckoutHidden,
    routeQuickPayment: routeQuickPayment,
    getCartSurface: cartSurface,
    getCartSections: sectionsForCart,
    afterAdd: afterAdd
  };
})();
